import { createApp } from 'vue'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/css/main.css'
import '@/assets/css/kioskCheckIn.css'
import './registerServiceWorker'
import emitter from '@/services/mitt'
import lang from '@/services/Language'

import { io } from 'socket.io-client'
import MoreFunction from '@/helpers/moreFunction'
import { inspect } from '@xstate/inspect'

import '@fontsource/montserrat'
import '@fontsource/montserrat/100.css'
import '@fontsource/montserrat/200.css'
import '@fontsource/montserrat/300.css'
import '@fontsource/montserrat/400.css'
import '@fontsource/montserrat/500.css'
import '@fontsource/montserrat/600.css'
import '@fontsource/montserrat/700.css'
import '@fontsource/montserrat/800.css'
import '@fontsource/inconsolata'
import '@fontsource/inconsolata/500.css'
import '@fontsource/inconsolata/600.css'
import '@fontsource/inconsolata/700.css'
import { getConfig, getDataConfig } from './services/environment'
if (process.env.VUE_APP_DEVELOPMENT) {
  inspect({
    iframe: false
  })
}

getConfig().then(async () => {
  const TODO_ENV = getDataConfig()
  const [App, router, store] = await Promise.all([
    import('./App.vue').then(m => m.default),
    import('./router').then(m => m.default),
    import('./store').then(m => m.default)
  ]).catch(_err => {
    location.reload()
  })
  window.socket = io(TODO_ENV.VUE_APP_SOCKET_URL)
  const app = createApp(App)
    .use(store)
    .use(router)
  app.config.globalProperties.emitter = emitter
  app.config.globalProperties.$l = lang
  app.config.globalProperties.$filters = {
    asteriks (data) {
      const moreFunction = new MoreFunction()
      return moreFunction.asteriskNamaConvert(data)
    }
  }
  app.mount('#app')
}).catch(() => {
  document.getElementById('app').innerHTML = 'Please wait ...'
  setTimeout(() => {
    location.reload()
  }, 10000)
})
